import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FloatingWindow clear" }

import { onMounted } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Back',
  setup(__props) {

const handleScrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "javascript:;",
      class: "FloatingWindow_list fr",
      id: "top",
      onClick: handleScrollTop
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "FloatingWindow_list_title" }, [
        _createElementVNode("dd", { class: "iconfont" }, [
          _createElementVNode("i", { class: "iconfont icon-xiangshangjiantou" })
        ]),
        _createElementVNode("dt", null, "TOP")
      ], -1)
    ]))
  ]))
}
}

})